// extracted by mini-css-extract-plugin
module.exports = {"root":"DesktopInjector_root__j9OL-"};